<div
	class="{{ pageHeaderWrapperStyleClassOverwrite }} page-header--separator"
	[ngClass]="{'page-header--separator': showHeaderSeparator}"
>

	<ng-container *ngIf="aboveHeaderContent">
		<ng-container *ngTemplateOutlet="aboveHeaderContent"></ng-container>
	</ng-container>

	<div class="row gx-0">
		<div class="col-auto me-auto">
			<div
				class="row mx-0"
				[ngClass]="{
					'select-text': titleIsSelectable
				}"
			>

				<!-- Title with back navigation -->
				<div
					*ngIf="showBackNav"
					class="row gx-0 cursor-pointer flex-nowrap align-items-center"
					(click)="navigateBack()"
					(mouseenter)="isHovered = true"
					(mouseleave)="isHovered = false"
				>
					<ng-container [ngTemplateOutlet]="titleTpl"></ng-container>
				</div>

				<!-- Title without back navigation -->
				<div
					*ngIf="!showBackNav"
					class="row gx-0 flex-nowrap"
				>
					<ng-container [ngTemplateOutlet]="titleTpl"></ng-container>
				</div>
			</div>
			<p
				*ngIf="secondaryTitle"
				class="entity-details-description--text mb-0"
			>{{ secondaryTitle }}</p>

			<div
				*ngIf="subcontent"
				class="pt-2">
				<ng-container *ngTemplateOutlet="subcontent"></ng-container>
			</div>
		</div>

		<div
			*ngIf="pageActionTpl"
			class="col-auto align-self-center"
			[ngClass]="{
				'ps-4 pe-0 ps-lg-0': showBackNav,
				'px-0': !showBackNav
			}"
		>
			<ng-container *ngTemplateOutlet="pageActionTpl"></ng-container>
		</div>
	</div>
</div>

<!-- ######################### TEMPLATES ######################### -->
<ng-template #titleTpl>
	<a
		*ngIf="showBackNav"
		class="col-auto navigateBack select-none"
		[ngClass]="{'hoverable': isHovered}"
	>
		<i class="ft-chevron-left"></i>
	</a>

	<p
		*ngIf="!titleAsInnerHtml; else titleTextAsInnerHTML"
		class="page-header--title col-auto mb-0"
		[ngClass]="{'hoverable': isHovered}"
		appIndicateElsterField
		[show]="showElsterIndicator"
		[styleClasses]="isHovered ? 'ms-1 flex-shrink-1 hovered' : 'ms-1 flex-shrink-1'"
	>{{ title }}</p>
</ng-template>

<ng-template #titleTextAsInnerHTML>
	<p
		class="page-header--title col-auto mb-0"
		[ngClass]="{'hoverable': isHovered}"
		appIndicateElsterField
		[show]="showElsterIndicator"
		[styleClasses]="isHovered ? 'ms-1 flex-shrink-1 hovered' : 'ms-1 flex-shrink-1'"
		[innerHTML]="titleAsInnerHtml"
	></p>
</ng-template>
